import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MicroLabel } from "@/components/decor/CropMarks";

const BrandPhilosophy = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      id="about"
      ref={ref}
      data-testid="brand-philosophy"
      className="relative overflow-hidden"
      style={{ background: "#0A0A0A", paddingTop: 120, paddingBottom: 120 }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12">
        <MicroLabel index={2} accent="#B89B5E">
          Brand Philosophy
        </MicroLabel>
      </div>

      <motion.div
        style={{ x }}
        className="mt-14 md:mt-20 whitespace-nowrap will-change-transform"
        aria-hidden
      >
        <div
          style={{
            fontFamily: "Montserrat",
            fontWeight: 900,
            fontSize: "clamp(56px, 14vw, 220px)",
            color: "#F5F1E8",
            letterSpacing: "-0.04em",
            lineHeight: 0.92,
            textTransform: "uppercase",
            display: "inline-block",
            paddingLeft: "8vw",
          }}
        >
          Touched · Carried · Gifted · Printed · Displayed · Packed
        </div>
      </motion.div>

      <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-12 mt-14 md:mt-24 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-2 md:border-t pt-6" style={{ borderColor: "rgba(192,192,192,0.15)" }}>
          <span className="ko-overline" style={{ color: "#C0C0C0" }}>
            01 / Manifesto
          </span>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="md:col-span-10 md:border-t pt-6"
          style={{
            borderColor: "rgba(192,192,192,0.15)",
            fontFamily: "Montserrat",
            fontWeight: 500,
            color: "#F5F1E8",
            fontSize: "clamp(22px, 2.4vw, 38px)",
            lineHeight: 1.3,
            letterSpacing: "-0.01em",
          }}
        >
          A brand is not only seen on screens.{" "}
          <span style={{ color: "#B89B5E" }}>
            It is touched, carried, gifted, printed, displayed, packed, worn, and
            remembered.
          </span>
        </motion.p>
      </div>
    </section>
  );
};

export default BrandPhilosophy;
